// @mui
import {
  TableRow,
  TableCell,
  Typography,

  Grid,
  Card,

  Table,
  TableBody,
  TableContainer,

  Paper,
} from '@mui/material';
import Iconify from 'src/components/Iconify';

// @types
import DownloadIcon from '@mui/icons-material/Download';
import { useNavigate } from 'react-router-dom';

//Localization
import useLocales from 'src/hooks/useLocales';
import { IBlock, IBlockDetails } from 'src/@types/Choqorak/Settings/Block';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores/store';
import Label from 'src/components/Label';
import { baseUrl } from 'src/api/baseUrl';
import { DateConverter } from '../../../../../common/DateConverter';
import { GetMonthName } from 'src/sections/common/GetMonthName';

type Props = {
  row?: IBlockDetails;
  clearBlock?: () => void;
};

export default observer(function ElectricityPaymentDetailTable({ row, clearBlock }: Props) {
  const { translate } = useLocales(); // Localization
  const navigate = useNavigate();
  const { ElectricityPaymentStore } = useStore();

  const {
    selectedElectricityPaymentDetail
  } = ElectricityPaymentStore;





  let Url = baseUrl;

  return (
    <>
      <Grid item xs={12} md={12} sx={{ padding: '50px' }}>
        <Card sx={{ p: 2 }}>
          <Typography
            variant="h5"
            sx={{ fontSize: 14, textAlign: 'center', mb: 2, color: 'warning.main' }}
            color="text.secondary"
            gutterBottom
          >
            <Label
              variant="ghost"
              sx={{ textTransform: 'capitalize', fontSize: 15, p: 2 }}
              color="warning"
            >
              {translate('ElectricityPayment.Title')} {translate('CRUD.Detail')}
            </Label>
          </Typography>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
              {/* <caption>A basic table example with a caption</caption> */}
              <TableBody>
                <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('RentPayment.Year')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.year}</TableCell>

                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('RentPayment.Month')}
                  </TableCell>
                  <TableCell align="left">{GetMonthName(selectedElectricityPaymentDetail?.month)}</TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('RentPayment.CustomerName')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.customerName}</TableCell>
                </TableRow>

                <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('ElectricMeter.ElectricMeterSerial')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.electricMeterSerial}</TableCell>

                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('ElectricMeter.LastElectricMeterDegree')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.previousElectricMeterDegree}</TableCell>

                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('ElectricityPayment.CurrentElectricMeterDegree')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.currentElectricMeterDegree}</TableCell>
                </TableRow>



                <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('RentPayment.ShopCode')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.shopCode}</TableCell>

                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('RentPayment.RecievedByUserName')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.recievedByUserName}</TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('RentPayment.RemainFromThePast')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.remnantsOfThePast}</TableCell>
                </TableRow>


                <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('RentPayment.PaymentAmount')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.paymentAmount}</TableCell>

                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('RentPayment.PaidAmount')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.paidAmount}</TableCell>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('RentPayment.RemainAmount')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.remainAmount}</TableCell>
                </TableRow>
                <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('RentPayment.PaymentDate')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.paymentDate !== null ? (
                    <DateConverter date={selectedElectricityPaymentDetail?.paymentDate} />
                  ) : (
                    ''
                  )}</TableCell>

                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('ElectricBox.ElectricBoxCode')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.electricBoxCode}</TableCell>

                </TableRow>




                <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                  <TableCell
                    align="left"
                    sx={{
                      fontWeight: 'bold',
                      color: 'info.main',
                      fontSize: '16px',
                    }}
                  >
                    {translate('RentPayment.Description')}
                  </TableCell>
                  <TableCell align="left">{selectedElectricityPaymentDetail?.description}</TableCell>

                  
                </TableRow>


              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Grid>

      {selectedElectricityPaymentDetail?.attachmentFiles.length > 0 ? (
        <Grid item xs={12} md={12} sx={{ padding: '50px' }}>

          <Card sx={{ p: 2 }}>
            <Typography
              variant="h5"
              sx={{ fontSize: 14, textAlign: 'center', mb: 2, color: 'warning.main' }}
              color="text.secondary"
              gutterBottom
            >
              <Label
                variant="ghost"
                sx={{ textTransform: 'capitalize', fontSize: 15, p: 2 }}
                color="warning"
              >
                {translate('contractsInfo.Attachments')}
              </Label>
            </Typography>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
                {/* <caption>A basic table example with a caption</caption> */}
                <TableBody>
                  {selectedElectricityPaymentDetail?.attachmentFiles.map((file: any, index: any) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{file.fileName}</TableCell>
                      <TableCell>
                        {/* Link Icon that opens the PDF in a new tab for viewing */}
                        <a href={Url! + file.path} style={{ color: 'orange' }} target="_blank" rel="noopener noreferrer">
                          <DownloadIcon />
                        </a>
                      </TableCell>

                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
      ) : (
        ''
      )}

    </>
  );
});
